import { FC, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslate } from 'hooks/useTranslate';
import { AI_NAME } from 'modules/ai/constants/aiName';
import AiUsageIndicator from 'modules/ai/components/AiUsageIndicator';
import InputText from 'modules/_shared/components/InputText';
import { useSocietyAiAgentPage } from '../context/SocietyAiAgentPageContext';
import { AiConversationSummary } from '../types/SocietyAiAgentPageContextType';
import NaviOrb from './NaviOrb';
import { groupConversations } from '../utils/groupConversations';

const ConversationSidebar: FC = () => {
  const { t } = useTranslate();
  const { societyId } = useParams<{ societyId: string }>();
  const { data, actions } = useSocietyAiAgentPage();

  const [search, setSearch] = useState<string>('');

  const grouped = groupConversations(
    data.conversations.filter((c: AiConversationSummary) =>
      c.title.toLowerCase().includes(search.toLowerCase())
    )
  );

  return (
    <aside className="navi-sidebar">
      <div className="navi-sidebar__header">
        <div className="navi-sidebar__brand">
          <NaviOrb size={24} showSparkles={false} />
          <span className="navi-sidebar__brand-name">{AI_NAME}</span>
        </div>
        <button
          type="button"
          className="navi-sidebar__new-btn"
          onClick={actions.handleResetConversation}
        >
          <span className="navi-sidebar__new-btn-icon">+</span>
        </button>
      </div>

      <div className="navi-sidebar__search-wrap">
        <InputText
          id="conversation-search"
          className="navi-sidebar__search-input"
          value={search}
          icon="ni-search"
          placeholder={t('SearchConversation')}
          onChange={setSearch}
          isClearable
        />
      </div>

      <nav className="navi-sidebar__list">
        {grouped.length === 0 ? (
          <p className="navi-sidebar__empty">{t('CHATBOT_NoConversations')}</p>
        ) : (
          grouped.map(({ group, items }) => (
            <div key={group} className="navi-sidebar__group">
              <span className="navi-sidebar__group-label">{t(group)}</span>
              {items.map((conv: AiConversationSummary) => (
                <button
                  key={conv.id}
                  type="button"
                  className={`navi-sidebar__item${
                    data.activeConversationId === conv.id
                      ? ' navi-sidebar__item--active'
                      : ''
                  }`}
                  onClick={() => actions.handleSelectConversation(conv.id)}
                >
                  <span className="navi-sidebar__item-title">{conv.title}</span>
                  <span className="navi-sidebar__item-time">
                    {new Date(conv.updatedAt).toLocaleTimeString('es-ES', {
                      hour: '2-digit',
                      minute: '2-digit',
                    })}
                  </span>
                </button>
              ))}
            </div>
          ))
        )}
      </nav>

      {societyId && <AiUsageIndicator societyId={societyId} />}
    </aside>
  );
};

export default ConversationSidebar;
